/* script */

// Components
import GenericExportModal from 'shared/ui/components/modals/GenericExportModal.vue';

const __vue_script__ = {
    name: 'AppscriptExportModal',

    extends: GenericExportModal,

    props: {
        jobScript: {
            type: String,
            required: true,
        },

        jobOptions: {
            type: Object,
            default: () => {}
        },
    },

    async created() {
        try {
            const bgJobDoc = await this.$services.appScripts.createJob(this.event._id, this.jobScript, {}, this.jobOptions);
            const { job } = await this.$services.appScripts.callAppScript(this.event._id, 'background-jobs/fetch-job-by-doc-id', { id: bgJobDoc._id });

            await this.trackJob(job.id);

            const doc = await this.$services.documents.getDocById(this.event._id, bgJobDoc._id);
            const filename = this.$utils.attachments.getAttachmentNames(doc)[0];

            if (!doc.filePath && filename) {
                // sets filename for to be downloaded file
                // see apps/shared/src/ui/mixins/common/export-modal.js -> downloadReport()
                this.defaultFileName = filename.replace(/\.\w+$/, '');

                doc.filePath = this.$utils.assets.getEventAttachmentPath(this.event._id, filename, doc._id);
            }

            this.downloadPath = doc.filePath;
        } catch (error) {
            this.handleError(error);
        }
    }
};

/* template */

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/modals/AppscriptExportModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__